import { render } from "./appointmentTitle.vue?vue&type=template&id=0e85b5d3"
import script from "./appointmentTitle.vue?vue&type=script&lang=js"
export * from "./appointmentTitle.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__